<template>
  <div class="container-fluid">
    <b-card class="card-transparent-background" no-body>
      <b-card-header class="p-0">
        <b-card-body class="py-2">
          <b-row class="mr-0">
            <b-col cols="6" class="pl-0"
              ><b-card-title class="card-title-astrology"
                >Content Management</b-card-title
              ></b-col
            >
            <b-col cols="6" class="justify-content-end pr-0">
              <!-- <b-button
                variant="astrology-info"
                id=""
                class="
                  btn btn-bumblebee btn-astrology btn-filter
                  m-0
                  float-right
                "
              >
                <font-awesome-icon
                  icon="fa-solid fa-square-plus"
                  class="mr-1"
                />
                Add new Object
              </b-button> -->
              <router-link
                to="/astrology_ventures/admin/content_management/add_object"
                class="
                  btn btn-bumblebee btn-astrology btn-astrology-info btn-filter
                  m-0
                  float-right
                "
              >
                <font-awesome-icon
                  icon="fa-solid fa-square-plus"
                  class="mr-1"
                />
                Add new Object
              </router-link>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card-header>
    </b-card>

    <b-overlay
      :show="overlay_show"
      rounded="sm"
      variant="astrology-info"
      opacity="0.5"
      blur="2px"
    >
      <b-card>
        <b-row class="mb-3">
          <!-- <b-col lg="3">
                <div id="objectTypeSelect" class="">
                  <select
                    id="selectFilterType"
                    data-style="select-with-transition"
                    class="form-control form-control-filter-astrology"
                    name="object_type"
                  >
                    <option value="">Select all object types</option>
                  </select>
                </div>
            </b-col> -->
          <b-col lg="3"
            ><v-select
              class="v-select-astrology select-filter"
              :options="objectTypes"
              :clearable="false"
              name="object_type"
              title="object_type"
              v-model="object_type"
              :reduce="(item) => item.code"
              placeholder="Select object type"
              required
              @input="changeTypeFilter"
            ></v-select
          ></b-col>
          <b-col lg="3"
            ><v-select
              class="v-select-astrology select-filter"
              :options="objectStatus"
              :clearable="false"
              name="object_status"
              title="object_status"
              v-model="object_status"
              :reduce="(item) => item.code"
              placeholder="Select object status"
              required
              @input="changeStatusFilter"
            ></v-select
          ></b-col>
        </b-row>
        <b-table-simple
          class="table table-no-bordered table-hover astrologyTable"
          id="contentTable"
          hover
          responsive
        >
          <b-thead>
            <b-tr>
              <b-th>Type</b-th>
              <b-th>Name</b-th>
              <b-th>Date</b-th>
              <b-th class="text-center">Status</b-th>
              <b-th class="text-center">Actions</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="item in objectsList" :key="item.id">
              <b-td>{{ item.type }}</b-td>
              <b-td>{{ item.name }}</b-td>

              <b-td>{{ item.date }}</b-td>
              <b-td class="centerTd">
                <span class="itemStatusSpan" :class="item.status + 'Status'">{{
                  item.status
                }}</span></b-td
              >
              <b-td class="centerTd">
                  <router-link
                :to="'/astrology_ventures/admin/content_management/object_info/'+item.id"
                class="
                  btn btn-action-table-astrology btn-edit-action mb-1
                "
              > <font-awesome-icon icon="fa-solid fa-square-pen" />
              </router-link>
                <!-- <b-button
                  variant="action-table-astrology"
                  class="btn-edit-action mb-1"
                >
                  <font-awesome-icon icon="fa-solid fa-square-pen" /> -->
                  <!-- <img
                      src="@/assets/images/astrology/edit-icon.png"
                      alt="edit icon" /> -->
                <!-- </b-button> -->
                <b-button
                  variant="action-table-astrology "
                  class="btn-delete-action mb-1"
                  @click="clickDeleteObject(item.id)"
                >
                  <font-awesome-icon icon="fa-solid fa-trash-can" />
                  <!-- <img
                      src="@/assets/images/astrology/delete-icon.png"
                      alt="delete icon" /> -->
                </b-button></b-td
              >
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>
    </b-overlay>

    <!-- delete modal -->
    <DeleteObject 
    client_name="AV"
    :object_id="selected_object_id" />
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import DeleteObject from './DeleteObject.vue'

var table;
export default {
  name: "AstrologyObjectList",
  components: {DeleteObject},
  data() {
    return {
      client_name: "AV",
      objectsList: [
        {
          id: 1,
          type: "Zodiac",
          name: "Zodiac 1",
          date: "11 Oct 2022",
          status: "published",
        },
        {
          id: 2,
          type: "House",
          name: "Zodiac 1",
          date: "11 Oct 2022",
          status: "published",
        },
        {
          id: 3,
          type: "Planet",
          name: "Planet 1",
          date: "11 Oct 2022",
          status: "draft",
        },
        {
          id: 4,
          type: "Natal aspect",
          name: "Aspect 1",
          date: "11 Oct 2022",
          status: "published",
        },
        {
          id: 5,
          type: "Elements",
          name: "Elements 1",
          date: "11 Oct 2022",
          status: "draft",
        },
        {
          id: 6,
          type: "Quadrants",
          name: "Quadrant 1",
          date: "11 Oct 2022",
          status: "draft",
        },
        {
          id: 7,
          type: "Transits Aspects",
          name: "Transit aspect 1",
          date: "11 Oct 2022",
          status: "draft",
        },
      ],
      table: null,

      objectTypes: [{ label: "All types", code: "" }],
      object_type: "",

      objectStatus: [{ label: "All status", code: "" }],
      object_status: "",

      overlay_show: false,
      selected_object_id: null,
    };
  },
  mounted() {
    // this.overlay_show = true;
    this.initTable();
    // this.getObjectsList();
    //
  },
  methods: {
    getObjectsList() {
      // console.log("here call user list");
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token);
      axios
        .get("/admin/accepted-list", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "AV",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          // console.log(table);
          // table.destroy();
          if (table != null) {
            table.destroy();
          }
          console.log(response);
          this.objectsList = response.data;
          // console.log(this.rowsData);
          var temp = this;
          setTimeout(function () {
            // console.log(table);
            // console.log(table == null);
            if (table == null) {
              temp.initTable();
            } else {
              // console.log(table.data());
              temp.initTable();
              // console.log(table.data());
              // table.destroy();
              // $('#sampleTable').DataTable().clear()
              // $('#sampleTable').DataTable().destroy()
              //
            }
          }, 1000);
          this.overlay_show = false;
          // table.ajax.reload()
        });
    },
    getUserList() {
      // console.log("here call user list");
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token);
    },
    initTable() {
      let temp = this;
      table = $("#contentTable").DataTable({
        ordering: false,
        info: true,
        destroy: true,
        responsive: true,
        // scrollY: "450px",
        // scrollCollapse: true,
        searching: true,
        lengthMenu: [
          [-1, 5, 10, 25, 50, 100],
          ["All", 5, 10, 25, 50, 100],
        ],
        columnDefs: [
          {
            targets: -1,
            orderable: false,
          },
          {
            targets: 3,
            render: function (data, type, full, meta) {
              // console.log("render");
              // console.log(data);
              // console.log(type);
              // console.log(full);
              // console.log(meta);
              if (type === "filter") {
                return $("#contentTable")
                  .DataTable()
                  .cell(meta.row, meta.col)
                  .nodes()
                  .to$()
                  .find(".itemStatusSpan")
                  .text();
              } else {
                return data;
              }
            },
          },
        ],
        // columns: this.$parent.columns,
        // data: this.$parent.rowsData,
        pagingType: "full_numbers",
        language: {
          // paginate: {
          //   previous: "<i class='fas fa-angle-left'></i>",
          //   next: "<i class='fas fa-angle-right'></i>",
          // },
          paginate: {
            previous: "<i class='fas fa-angle-left'></i>",
            next: "<i class='fas fa-angle-right'></i>",
            first: "<i class='fas fa-angle-double-left'></i>",
            last: "<i class='fas fa-angle-double-right'></i>",
          },
          search: "",
          searchPlaceholder: "Search ",
        },
        initComplete: function () {
          var column = this.api().column(0);
          column
            .data()
            .unique()
            .sort()
            .each(function (d, j) {
              //   select.append('<option value="' + d + '">' + d + "</option>");
              //   console.log(temp.objectTypes);
              temp.objectTypes.push({ label: d, code: d });
            });
          ///////
          var column3 = this.api().column(3);
          column3
            .data()
            .unique()
            .sort()
            .each(function (d, j) {
              // console.log(d);
              // console.log(j);
              // console.log($(d).html());
              // console.log($(d).text());
              let val = $(d).text();
              const val2 = val.charAt(0).toUpperCase() + val.slice(1);
              //   select.append('<option value="' + d + '">' + d + "</option>");
              // console.log(temp.objectStatus, val2);
              temp.objectStatus.push({ label: val2, code: val2 });
            });
        },
      });
    },
    changeTypeFilter() {
      console.log(this.object_type);
      table.column(0).search(this.object_type).draw();
    },
    changeStatusFilter() {
      console.log(this.object_status.toUpperCase());
      table.column(3).search(this.object_status.toUpperCase()).draw();
    },
    clickDeleteObject(id) {
      console.log("Delete object", id);
      this.selected_object_id = id;
      this.$root.$emit("bv::show::modal", "deleteObjectModal");
    },
   
  },
};
</script>


// WEBPACK FOOTER //
// src/components/astrology_ventures/admin/content_management/List.vue